import { CheckboxGroupInput, Datagrid, Filter, NumberField, TextField, TextInput } from 'react-admin'

import { CustomDateField } from 'components/Fields'
import { CTXLoadExternalStatusChoices } from 'helpers/constants'
import CTList from '../List'

const CTXLoadFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" />
    <TextInput label="Ref ID" source="human_id" alwaysOn />
    <CheckboxGroupInput label="Status" source="ctx_status" choices={CTXLoadExternalStatusChoices} />
  </Filter>
)

export const CTXLoadList = (props: any) => {
  return (
    <CTList bulkActionButtons={false} filters={<CTXLoadFilter />} title="CT Exchange Loads" {...props}>
      <Datagrid optimized rowClick="show">
        <TextField source="human_id" label="Human Id (Ref Code)" />
        <TextField source="company_name" label="Company" />
        <TextField source="equipment[0]" label="Equipment" />
        <TextField source="origin_location" label="Origin" />
        <CustomDateField source="origin_pickup_date" label="Pick-up Time" format="MM/dd/yyyy HH:mm" />
        <TextField source="dest_location" label="Destination" />
        <CustomDateField source="dest_dropoff_date" label="Drop-off Time" format="MM/dd/yyyy HH:mm" />
        <NumberField source="trip_rate" label="Trip rate" />
        <NumberField label="Trip Distance (mi)" source="trip_distance_mi" />
        <TextField source="ctx_status" label="Status" />
      </Datagrid>
    </CTList>
  )
}
